import { Link } from 'react-router-dom'
import './MinhasCompras.css'

function MinhasCompras() {
    return (
        <div className="minhas-compras-page">
            <div className="container">
                <div className="page-header">
                    <h1>Minhas Compras</h1>
                    <p>Histórico das suas negociações no Agroov</p>
                </div>

                <div className="empty-state-container">
                    <div className="empty-icon">🛒</div>
                    <h2>Você ainda não realizou nenhuma compra</h2>
                    <p>Encontre o gado ideal para o seu rebanho entre milhares de ofertas verificadas.</p>
                    <Link to="/anuncios" className="btn btn-primary btn-lg mt-4">
                        Explorar Anúncios
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default MinhasCompras
